// PHASE 9: Are you ready to commit to your language journey?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🚀',
    title: 'pages.onboarding.finalCommitment.answer1',
    subtitle: 'pages.onboarding.finalCommitment.answer1Subtitle',
  },
  {
    emoji: '💪',
    title: 'pages.onboarding.finalCommitment.answer2',
    subtitle: 'pages.onboarding.finalCommitment.answer2Subtitle',
  },
  {
    emoji: '🌱',
    title: 'pages.onboarding.finalCommitment.answer3',
    subtitle: 'pages.onboarding.finalCommitment.answer3Subtitle',
  },
]

export default function FinalCommitmentPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.finalCommitment.title"
      subtitle="pages.onboarding.finalCommitment.subtitle"
    />
  )
}
